import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'CredentialRejectedReasons',
  inputShow: gql`
    query credentialRejectedReasons($input: CredentialRejectedReasonQueryInput) {
      credentialRejectedReasons(input: $input) {
        id
        label
        name
      }
    }
  `,
  create: Create,
  edit: Edit,
  list: List,
  show: Show,
  options: {
    group: false,
  },
};
